import React from 'react';
import { Outlet } from 'react-router-dom';

const AuthLayout = () => {
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f0fdf4' }}>
      <Outlet />
    </div>
  );
};

export default AuthLayout;
